import { MetingResult, ParceResult } from './types';

const parceResult = (data: MetingResult): ParceResult => {
  const result = data.reduce(
    (res, { id, title, text, file_url }) => {
      res.options.push({
        text: title || '',
        value: id || '',
      });
      res.data.push({
        id: id || '',
        description: text || '',
        file: file_url || '',
      });
      return res;
    },
    {
      options: [],
      data: [],
    } as ParceResult,
  );

  return result;
};

export default parceResult;



// WEBPACK FOOTER //
// ./src/services/mentoring/utils/parceResult.ts